import type { AppConfig } from '../types';

function readStaticEnv(value: string | undefined): string | null {
  const trimmed = value?.trim();
  return trimmed || null;
}

function readStaticTruthy(value: string | undefined): boolean {
  const normalized = readStaticEnv(value)?.toLowerCase();
  return normalized === '1' || normalized === 'true' || normalized === 'yes';
}

/** Local multi-tenant dev: tenant id when Domi login is skipped. */
export function readDevTenantId(): string | null {
  // Static `process.env.*` access is required — Next.js only inlines named keys.
  return readStaticEnv(process.env.OD_DEV_TENANT_ID);
}

/** Skip first-run onboarding (Connect / About you / Newsletter). */
export function readDevSkipOnboarding(): boolean {
  return readStaticTruthy(process.env.OD_DEV_SKIP_ONBOARDING);
}

/** Default local CLI agent id, e.g. `pi`. */
export function readDevDefaultAgentId(): string | null {
  return readStaticEnv(process.env.OD_DEV_DEFAULT_AGENT);
}

export function applyDevBootstrapDefaults(config: AppConfig): AppConfig {
  if (!readDevSkipOnboarding()) return config;
  const agentId = readDevDefaultAgentId() ?? config.agentId;
  return {
    ...config,
    onboardingCompleted: true,
    mode: 'daemon',
    ...(agentId ? { agentId } : {}),
  };
}
